import React from 'react';
import PropTypes from 'prop-types';
import Classes from '../Classes';

// This component is designed to be used inside a React Bootstrap
// Overlay component. The Overlay automatically inserts a 'style' property
// that contains the left and top coordinates for where the tooltip
// should be positioned.
const CustomOverlayAwareTooltip = ({ style, message, iconClass }) => {
  // Get left and top positions from Bootstrap 'style' property.
  const { left, top } = style;
  const myStyle = {
    left,
    top,
    position: 'absolute',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
    border: '1px solid #CCC',
    borderRadius: 3,
    padding: 2,
    zIndex: 3
  };
  return (
    <div
      data-testid="CustomOverlayAwareTooltip"
      className={`${Classes.themeButtonColor} ${Classes.copyComponent.customOverlayToolTip}`}
      style={myStyle}
    >
      <div className={iconClass} />
      <span style={{ fontSize: 'smaller' }}>{message}</span>
    </div>
  );
};

CustomOverlayAwareTooltip.propTypes = {
  style: PropTypes.object,
  message: PropTypes.string.isRequired,
  iconClass: PropTypes.string
};

export default CustomOverlayAwareTooltip;
